exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ingreso{margin:30px;border-radius:15px!important;border:0!important;width:250px;align-items:center;transition:.2s;z-index:0;cursor:pointer}.ingreso:hover{box-shadow:-1px 11px 16px 1px rgba(0,0,0,.32);transition:.2s;transform:scaleX(1.05) scaleY(1.05);z-index:1}.logo-inicio{display:block;padding-bottom:60px;max-width:600px;margin:auto}@media screen and (max-width:600px){.logo-inicio{width:80%;margin:20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-745b83e0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/startPage/Inicial.vue
// module id = 415
// module chunks = 0